module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst webUrl = model.tripAttributes[`${config.documentType}Url`]\nconst pdfUrl = `${webUrl}.pdf`\nconst webCode = model.tripAttributes[`${config.documentType}QRCodeWeb`]\nconst pdfCode = model.tripAttributes[`${config.documentType}QRCodePDF`]\n%><div><%\nif(webUrl && webCode){\n%><a href=\"<%= webUrl %>\" target=\"_blank\"><%\n%><img src=\"<%- webCode %>\" alt=\"web\" title=\"web\" /><%\n%></a><%\n}\nif(pdfUrl && pdfCode){\n%><a href=\"<%= pdfUrl %>\" target=\"_blank\"><%\n%><img src=\"<%- pdfCode %>\" alt=\"pdf\" title=\"pdf\" /><%\n%></a><%\n}\n%></div>"
  , __filename = "components/templates/core/documents/qrCodes/qrCodes.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const webUrl = model.tripAttributes[`${config.documentType}Url`]
const pdfUrl = `${webUrl}.pdf`
const webCode = model.tripAttributes[`${config.documentType}QRCodeWeb`]
const pdfCode = model.tripAttributes[`${config.documentType}QRCodePDF`]

    ; __line = 6
    ; __append("<div>")
    ; 
if(webUrl && webCode){

    ; __line = 8
    ; __append("<a href=\"")
    ; __append(escapeFn( webUrl ))
    ; __append("\" target=\"_blank\">")
    ; 

    ; __line = 9
    ; __append("<img src=\"")
    ; __append( webCode )
    ; __append("\" alt=\"web\" title=\"web\" />")
    ; 

    ; __line = 10
    ; __append("</a>")
    ; 
}
if(pdfUrl && pdfCode){

    ; __line = 13
    ; __append("<a href=\"")
    ; __append(escapeFn( pdfUrl ))
    ; __append("\" target=\"_blank\">")
    ; 

    ; __line = 14
    ; __append("<img src=\"")
    ; __append( pdfCode )
    ; __append("\" alt=\"pdf\" title=\"pdf\" />")
    ; 

    ; __line = 15
    ; __append("</a>")
    ; 
}

    ; __line = 17
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/documents/qrCodes/qrCodes.ejs

}